import { useContext } from 'react';
import { InjectorContext } from './injector.provider';
import type {
    TAngularServiceKeys,
    IAngularServices
} from '~/types/angular.types';

/**
 * @deprecated This hook is deprecated and will be removed in migration to React first.
 */
export const useInjector = <T extends readonly TAngularServiceKeys[]>(
    dependencies: T
) => {
    const injector: angular.auto.IInjectorService = useContext(InjectorContext);

    return dependencies.reduce((result, dependency) => {
        // This is to make sure we're using it from the Angular app / that the service exists. Returns null if not.
        if (injector === null) {
            result[dependency] = null;
        } else {
            result[dependency] = injector.get(dependency);
        }

        return result;
    }, {} as { [K in T[number]]: IAngularServices[K] });
};
